// StatusHero.jsx
import React, { useContext, useMemo } from "react";
import "./StatusHero.css";
import { translations } from "../../../utils/lang";
import { Context } from "../../../context/Context";

const MAIN_STATUSES = [
  { key: "pending", className: "action-pending" },
  { key: "inprogress", className: "action-inprogress" },
  { key: "active", className: "action-active" },
  { key: "completed", className: "action-completed" },
  { key: "canceled", className: "action-canceled" },
  { key: "rejected", className: "action-rejected" },
];

export default function StatusHero({ statuses = [] }) {
  const { lang } = useContext(Context);

  const summary = useMemo(() => {
    const initial = MAIN_STATUSES.reduce((acc, s) => {
      acc[s.key] = 0;
      return acc;
    }, {});

    statuses.forEach((item) => {
      const key = item.status?.toLowerCase();
      if (key && Object.prototype.hasOwnProperty.call(initial, key)) {
        initial[key] += 1;
      }
    });

    return initial;
  }, [statuses]);

  return (
    <div className="status-hero">
      {MAIN_STATUSES.map((s) => (
        <div key={s.key} className={`actions-status-item ${s.className}`}>
          <span>{translations[lang].Operation.status[s.key]}</span>
          <span>{summary[s.key]}</span>
        </div>
      ))}
    </div>
  );
}